import React, { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PregnancyIcon from "../../assets/images/icons/pregnancy-small-4.png";
import { useEffect} from 'react';
import { Endpoints } from "../../Global/Endpoints";
import { useLocation } from "react-router-dom";

const RecipeCard = () => {
  const [loading, setLoading] = useState(false);
  const [recipe, setRecipe] = useState(null); // State to store recipe data
  const token = localStorage.getItem("AccessToken");
  const contract = useSelector((state) => state.userData);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const selectedWeek = location.state?.selectedWeek

   // Fetch recipe data on component mount
   useEffect(() => {
    const fetchRecipe = async () => {
      setLoading(true); // Show loading state during API call
      const params = {
        EmailID: contract.userData.EmailID,
        DeviceType: "PatientPortal",
        WeekNo: selectedWeek,
      };

      try {
        const response = await axios.post(
          Endpoints.LoadMaternityWeeklyRecipe,
          `_Params=${encodeURIComponent(JSON.stringify(params))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data) {
          setRecipe(response.data); // Set the recipe data in state
        }
      } catch (error) {
        alert("Failed to load recipe. Please try again.");
      } finally {
        setLoading(false); // Remove loading state
      }
    };

    fetchRecipe();
  }, [contract, token,selectedWeek]); // Dependencies to re-trigger if contract or token changes


  const handleBackClick = () => {
    navigate(-1);
  };

  const handleButtonClick=(value)=>
    {
      navigate('/baby-devlopment', { state: {value:value, week: selectedWeek } });
    }
  
  return (
    <>
      <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
        <button onClick={handleBackClick} className="win-back-btn me-3">
          <span>
            <i className="bi bi-chevron-left"></i> {t("back")}
          </span>
        </button>
        <h2 className="page-heading">&nbsp;</h2>
      </div>
      <div className="col-lg-6 mt-4 d-flex justify-content-end flex-sm-row flex-column align-items-center weekly-pregnancy-tracker-buttons">
      <button
          className="win-btn-with-icon baby-btn"
          onClick={() => handleButtonClick("Baby")}
        >
          {(t('baby'))}
        </button>
        <button
          className="win-btn-with-icon mom-btn ms-3"
          onClick={() => handleButtonClick("Body")}
        >
         {(t('mom'))}
        </button>
        <button
          className="win-btn-with-icon nutrition-btn ms-3"
          onClick={() => handleButtonClick("Nutrition")}
        >
          {(t('nutrition'))}
        </button>
        <button
          className="win-btn-with-icon whats-next-btn ms-3"
          onClick={() => handleButtonClick("Tests")}
        >
         {(t('whatnext'))}
        </button>
      </div>


      <div className="weekly-tracker-inner-pages">
        
      {recipe && (recipe.RecipeName || recipe.RecipeImagePath || recipe.Topics.length > 0) ? (
  <>
    <div className="weekly-tracker-inner-page-icon-wrapper-no-bg">
      {recipe.RecipeImagePath && (
        <img src={recipe.RecipeImagePath} alt="" className="weekly-tracker-icon" />
      )}
    </div>
    <div className="weekly-tracker-inner-page-content-wrapper">
      {recipe.RecipeName && <h2 className="page-heading">{recipe.RecipeName}</h2>}
      {recipe.ScreenHeader && (
        <p dangerouslySetInnerHTML={{ __html: recipe.ScreenHeader }}></p>
      )}

      {recipe.Ingredients && (
        <div className="weekly-tracker-ingredients-block">
          <h2 className="ingredients-block-heading">{t('ingredients')}</h2>
          <p
            className="ingredients-block-content"
            dangerouslySetInnerHTML={{ __html: recipe.Ingredients }}
          ></p>
        </div>
      )}

      {recipe.Topics && recipe.Topics.length > 0 && (
        <>
          {recipe.Topics.map((topic, index) => (
            <div key={index} className="weekly-tracker-inner-page-block">
              <h3 className="block-heading">{topic.FoodItem}</h3>
              <p
                className="block-content"
                dangerouslySetInnerHTML={{ __html: topic.FoodItemDetails }}
              ></p>
            </div>
          ))}
        </>
      )}
    </div>
  </>
) : (
  <p className="no-recipe-message">There is no recipe for this week.</p>
)}


          {loading && (
            <div className="loading-container">
            <div className="loading"></div>        
            <h2 className="loading-text">{t("loading")}</h2>
          </div>
          )}
      </div>
    </>
  );
};

export default RecipeCard;
